"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionHandler = void 0;
const message_1 = require("../message");
const base_handler_1 = require("./base_handler");
const node_handler_1 = require("./node_handler");
class SessionHandler extends base_handler_1.BaseHandler {
    constructor(connection) {
        super(connection, "-1");
    }
    handleMessage(message) {
        super.handleMessage(message);
    }
    async createNode(nodeName) {
        const response = await this.sendRequest(message_1.MessageType.CREATE_NODE, {
            node_name: nodeName,
        });
        const node = new node_handler_1.NodeHandler(this.connection, response.content["node_id"]);
        this.attach(node);
        return node;
    }
}
exports.SessionHandler = SessionHandler;
